@if (errorMessage) {
  {{ errorMessage | translate }}
} @else {
  {{ 'Error' | translate }}
}

